<template>
    <div class="main" >
        <dv-border-box-10>

            <div  v-if='JSON.stringify(attendance) !="{}"' class="contents">
              <transition
                name="el-fade-in-linear"
              >
                <div v-show="isShow" class="transition-box">
                  <div class="avatars">
                    <img :src="attendance.imageUrl" class='image' />
                  </div>
                  <div class="information">
                      <div class="name">{{ attendance.name ? attendance.name : '未知'}}</div>
                      <div> 
                        <span :class="attendance.direction == '01' ? 'text-darkgreen':'text-red' ">
                          {{attendance.direction == '01' ? '进场':'出场'}}
                        </span>
                      </div>
                      <div>班组名称:{{ attendance.teamName}}</div>
                      <div>工种:{{ attendance.type ? attendance.type : '未定义' }}</div>
                      <div>{{ attendance.date }}</div>
                  </div>
                </div>
              </transition>
            </div>
            <div v-else  class='text-white main empty'>
              暂无考勤信息
          </div>
        </dv-border-box-10>
    </div>
  </template>
  <style lang="scss" scoped>
  .main {
    width: 100%;
    height: 100%;
    background: rgba(47, 79, 79, 0.1);
    /* overflow: hidden; */
  }
  .image{
    width:90%;
    height:90%;
  }
  .empty{
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size:2em;
  }
  .contents {
    width: 100%;
    height: 100%;
    border-top: 2px solid #87cefa;
  }
  .text-darkgreen {
    color: #7fffd4;
  }
  .transition-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
  }
  .avatars {
    width:50%;
    height: 100%;
    display:flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: space-around;
  }
  .information {
    padding: 0 0 0 10px;
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .information div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width:100%;
    font-size: 30px;
    color: #87cefa;
    &:nth-child(1){
      font-size: 40px;
    }
    &:nth-child(2){
      font-size: 40px;
    }
    
  }
  </style>
  <script>

  // import '../../assets/rem'
  export default {
    data() {
      return {
        // attendanceList: [ ],
        // newData  : [],
        isShow:false,
        attendance :{

        },
      };
    },
    methods: {
      changeData(data){
        if(data){
            this.isShow = false;
            this.attendance = data;
            setTimeout(() => {
                this.isShow = true;
            }, 250);
        }
      },
    },
    mounted() {
    },
  };
  </script>
  